import { useApiCall } from "@jane/lib/src/api";
import { Input } from "@jane/lib/src/components/form/Input";
import {FC, useState} from "react";
import {config} from "../config";
import {availableLearnIcons} from "../pages/learn/availableLearnIcons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconStore} from "../../../lib/src/components/form/IconStore";
import {LearnCategory} from "../../../lib/src/api/repositories/learn-repository";
import {faTriangleExclamation} from "@fortawesome/pro-solid-svg-icons";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const AddLearnCategoryModal: FC<{parentCategory: LearnCategory|null, isPinned: boolean, onFinished: () => void}> = (props) => {
  const {learn} = useApiCall(config)
  const [name, setName] = useState('')
  const [selectedIcon, setSelectedIcon] = useState<string>(props.parentCategory?.icon ?? '')
  const save = async () => {
    await learn.addCategory(name, props.parentCategory?.id ?? null, props.isPinned, selectedIcon)
    props.onFinished()
  }

  const icons = Object.entries(availableLearnIcons).filter(
    ([name, icon], index, self) =>
      self.findIndex(([_, i]) => i === icon) === index
  );
  return <div className={"flex flex-col space-y-3"}>
    {props.parentCategory &&
      <div className={'flex flex-row border border-yellow-400 bg-yellow-50 rounded-sm px-3 py-2 items-center'}>
        <FontAwesomeIcon icon={faTriangleExclamation} className={'mr-3 text-yellow-400'}/>
        <div>
          <div>Deze categorie erft vanuit zichzelf het icoon over van de hoofdcategorie</div>
          <div>Wil je toch een ander? Dan kan je hieronder kiezen.</div>
        </div>
      </div>
    }
    <div className={'grid grid-cols-5'}>
      <div className={'col-span-3'}>
        <IconStore iconList={icons} selected={selectedIcon} setSelected={setSelectedIcon} />
      </div>
      <div className={'col-span-2 px-2'}>
        <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
      </div>
    </div>
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </div>
}